// Module
var code = `<inline-panel on-hide="\$ctrl.onHide()">

  <div class="inline-panel__list">
    <div class="inline-panel__container {{item.clazz}}"
         ng-repeat="item in \$ctrl.keyValueDetails">
      <label class="inline-panel__label" ng-if="item.translate">{{item.label | translate:'TASK_DESCRIPTION'}}:</label>
      <label class="inline-panel__label" ng-if="!item.translate">{{item.label}}:</label>
      <div class="inline-panel__value">
        <span ng-if="item.type === 'FILE'">
          <file-id-upload
            single-file="true"
            ng-model="item.value"
            ng-disabled="true"
            show-remarks="false"
            enable-webcam="false"
            max-files="1"
          >
          </file-id-upload>
        </span>
        <span ng-if="item.type !== 'FILE'">{{item.value}}</span>
      </div>
    </div>
  </div>

  <div class="inline-panel-footer" ng-if="\$ctrl.action.approvalStatus === 'PENDING'">
    <button class="btn btn-primary action-button" type="button"
            ng-click="\$ctrl.navigateToCustomerProfile()"
            permissions="CST_CIF_READ, CST_ALL_BRANCHES_ACCESS"
            permission-context="{customerId: \$ctrl.getCustomerId()}"
            ng-show="\$ctrl.action.taskGroup === 'CUSTOMER' || ['CreateCustomer', 'ProcessCustomerApplication', 'ProcessAgentApplication', 'ApproveAgentCandidacy'].includes(\$ctrl.action.name)">
      View profile
    </button>
    <approval-action
      ng-if="\$ctrl.action.approvalStatus === 'PENDING'"
      level-label="Local override level"
      button-label="Local override"
      approval-action="\$ctrl.localOverrideAction"
      levels="\$ctrl.getLocalOverrideLevels(\$ctrl.action)"
      button-class="btn-primary action-button"
      task="\$ctrl.action"
    >
    </approval-action>
    <approval-action
      level-label="Approve level"
      button-label="Approve"
      ng-if="\$ctrl.action.canBeApproved"
      approval-action="\$ctrl.approveAction"
      levels="\$ctrl.getApprovalLevels(\$ctrl.action)"
      task="\$ctrl.action"
      button-class="btn-success action-button"
    >
    </approval-action>
    <button class="btn btn-danger action-button"
            type="button"
            ng-if="\$ctrl.action.canBeRejected"
            ng-click="\$ctrl.reject(\$ctrl.action, \$event)">
      Reject
    </button>
    <button class="btn btn-danger action-button"
            type="button"
            ng-if="\$ctrl.action.canBeRevoked"
            ng-click="\$ctrl.revoke(\$ctrl.action, \$event)">
      Reject
    </button>
  </div>

</inline-panel>

<local-override
  task="\$ctrl.overrideTask"
  on-pin-entered="\$ctrl.pinEntered(task, pin, user)">
</local-override>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/actions/action-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;